import React, { useState, useEffect } from 'react';
import contentService from '../services/contentService';
import './InfluencerModal.css';

const PLATFORM_ICONS = {
  instagram: 'https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/instagram.webp',
  tiktok:    'https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/logo-tiktok-3.avif',
  facebook:  'https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/logos/faccebook.webp',
};

const SocialInput = ({ platform, icon, label, name, value, onChange, placeholder, disabled, error }) => (
  <div className="form-group">
    <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      {icon ? (
        <img src={icon} alt={platform} style={{ width: '16px', height: '16px', objectFit: 'contain', borderRadius: '3px' }} />
      ) : null}
      {label}
    </label>
    <div className="input-with-icon">
      <span className="input-icon" style={{ color: '#9ca3af', fontWeight: 600 }}>@</span>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="form-control with-icon"
        disabled={disabled}
        maxLength={100}
        style={{ paddingLeft: '2.5rem' }}
      />
    </div>
    {error && <span className="error-message">{error}</span>}
  </div>
);

const CompetenciaModal = ({ competidor, onClose }) => {
  const [formData, setFormData] = useState({
    name:              competidor?.name || '',
    ig_username:       competidor?.ig_username || '',
    tk_username:       competidor?.tk_username || '',
    fb_username:       competidor?.fb_username || '',
    notes:             competidor?.notes || '',
    profile_image_url: competidor?.profile_image_url || '',
    is_active:         competidor?.is_active !== undefined ? competidor.is_active : true,
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [platforms, setPlatforms] = useState([]);
  const [selectedPlatformIds, setSelectedPlatformIds] = useState(
    competidor?.platforms?.map(p => p.id) || []
  );

  useEffect(() => {
    loadPlatforms();
  }, []);

  const loadPlatforms = async () => {
    try {
      const res = await contentService.getPlatforms();
      const list = Array.isArray(res.data) ? res.data : (res.data?.results || []);
      setPlatforms(list);
    } catch (err) {
      console.error('Error loading platforms:', err);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'El nombre es requerido';
    if (!formData.ig_username.trim() && !formData.tk_username.trim() && !formData.fb_username.trim()) {
      newErrors.ig_username = 'Ingresa al menos un usuario (Instagram, TikTok o Facebook)';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      // username general = primer username disponible (retrocompatibilidad)
      const fallbackUsername =
        formData.ig_username.trim() ||
        formData.tk_username.trim() ||
        formData.fb_username.trim();

      const dataToSend = {
        name:              formData.name.trim(),
        username:          fallbackUsername,   // campo legacy, siempre enviar algo
        ig_username:       formData.ig_username.trim(),
        tk_username:       formData.tk_username.trim(),
        fb_username:       formData.fb_username.trim(),
        notes:             formData.notes.trim() || '',
        profile_image_url: formData.profile_image_url.trim() || '',
        is_active:         formData.is_active,
        platform_ids:      selectedPlatformIds,
      };

      if (competidor) {
        await contentService.updateCompetidor(competidor.id, dataToSend);
        alert('✅ Cuenta actualizada exitosamente');
      } else {
        await contentService.createCompetidor(dataToSend);
        alert('✅ Cuenta creada exitosamente');
      }
      onClose();
    } catch (error) {
      console.error('Error saving competidor:', error);
      let msg = 'Error al guardar la cuenta';
      if (error.response?.data) {
        const d = error.response.data;
        if (typeof d === 'object' && !d.detail) {
          msg = Object.entries(d)
            .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`)
            .join('\n');
        } else {
          msg = d.detail || d.message || msg;
        }
      }
      alert(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    // limpiar error global de usuario si el usuario empieza a escribir en cualquier campo
    if (['ig_username', 'tk_username', 'fb_username'].includes(name)) {
      setErrors(prev => ({ ...prev, ig_username: '' }));
    }
  };

  const togglePlatform = (id) => {
    setSelectedPlatformIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-l" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-header-content">
            <div className="modal-header-icon">{competidor ? '✏️' : '➕'}</div>
            <div className="modal-header-text">
              <h2 className="modal-header-title">
                {competidor ? 'Editar' : 'Nueva'} cuenta de competencia
              </h2>
              <p className="modal-header-subtitle">
                {competidor
                  ? 'Modifica los datos de esta cuenta'
                  : 'Agrega una cuenta de Instagram, TikTok o Facebook de la competencia'}
              </p>
            </div>
          </div>
          <button onClick={onClose} className="modal-close-btn" disabled={loading} title="Cerrar">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-content">

            {/* Nombre */}
            <div className="form-group">
              <label className="form-label">
                Nombre de la marca / cuenta <span className="required">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Ej: Marca Competidora"
                className="form-control"
                disabled={loading}
                maxLength={200}
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>

            {/* Separador de usuarios por red social */}
            <div style={{ margin: '4px 0 8px' }}>
              <p className="form-label" style={{ marginBottom: '2px' }}>
                Usuarios por red social <span className="required">*</span>
              </p>
              <p style={{ fontSize: '12px', color: '#9ca3af', margin: 0 }}>
                Ingresa al menos uno. Se usará para obtener las métricas de cada plataforma.
              </p>
            </div>

            {errors.ig_username && (
              <div style={{
                background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px',
                padding: '8px 12px', marginBottom: '8px',
              }}>
                <span className="error-message" style={{ fontSize: '13px' }}>{errors.ig_username}</span>
              </div>
            )}

            {/* Instagram */}
            <SocialInput
              platform="instagram"
              icon={PLATFORM_ICONS.instagram}
              label="Usuario de Instagram"
              name="ig_username"
              value={formData.ig_username}
              onChange={handleChange}
              placeholder="usuario_instagram"
              disabled={loading}
              error={null}
            />

            {/* TikTok */}
            <SocialInput
              platform="tiktok"
              icon={PLATFORM_ICONS.tiktok}
              label="Usuario de TikTok"
              name="tk_username"
              value={formData.tk_username}
              onChange={handleChange}
              placeholder="usuario_tiktok"
              disabled={loading}
              error={null}
            />

            {/* Facebook */}
            <SocialInput
              platform="facebook"
              icon={PLATFORM_ICONS.facebook}
              label="Usuario de Facebook"
              name="fb_username"
              value={formData.fb_username}
              onChange={handleChange}
              placeholder="pagina.o.usuario"
              disabled={loading}
              error={null}
            />

            {/* Plataformas */}
            {platforms.length > 0 && (
              <div className="form-group">
                <label className="form-label">Plataformas activas</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
                  {platforms.map(p => (
                    <button
                      key={p.id}
                      type="button"
                      onClick={() => togglePlatform(p.id)}
                      style={{
                        padding: '6px 14px',
                        borderRadius: '20px',
                        border: selectedPlatformIds.includes(p.id)
                          ? '2px solid #3b82f6'
                          : '2px solid #e5e7eb',
                        background: selectedPlatformIds.includes(p.id) ? '#eff6ff' : '#fff',
                        color: selectedPlatformIds.includes(p.id) ? '#3b82f6' : '#374151',
                        fontWeight: selectedPlatformIds.includes(p.id) ? 600 : 400,
                        cursor: 'pointer',
                        fontSize: '13px',
                        transition: 'all 0.15s',
                      }}
                    >
                      {p.name}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* URL imagen */}
            <div className="form-group">
              <label className="form-label">URL de imagen de perfil</label>
              <input
                type="url"
                name="profile_image_url"
                value={formData.profile_image_url}
                onChange={handleChange}
                placeholder="https://..."
                className="form-control"
                disabled={loading}
              />
            </div>

            {/* Notas */}
            <div className="form-group">
              <label className="form-label">Notas</label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                placeholder="Descripción, sector, observaciones..."
                className="form-control"
                rows={3}
                disabled={loading}
              />
            </div>

            {/* Activo */}
            <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                name="is_active"
                id="is_active"
                checked={formData.is_active}
                onChange={handleChange}
                disabled={loading}
              />
              <label htmlFor="is_active" className="form-label" style={{ margin: 0, cursor: 'pointer' }}>
                Cuenta activa
              </label>
            </div>

          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn-cancel" disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Guardando...' : competidor ? 'Guardar cambios' : 'Crear cuenta'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompetenciaModal;
